import { useState } from "react";
import { appConfig } from "@/config";
import { clearToken } from "@/lib/api";
import { VersionModal } from "@/components/dashboard/VersionModal";

interface HeaderProps {
  onMenuClick: () => void;
  userEmail?: string | null;
  onSignOut?: () => void;
}

export function Header({ onMenuClick, userEmail, onSignOut }: HeaderProps) {
  const [versionOpen, setVersionOpen] = useState(false);
  const envLabel =
    appConfig.environment.charAt(0).toUpperCase() + appConfig.environment.slice(1);

  return (
    <>
      <header className="app-header">
        <div style={{ display: "flex", alignItems: "center", gap: "0.75rem" }}>
          <button
            type="button"
            className="app-header__menu-btn"
            onClick={onMenuClick}
            aria-label="Open navigation menu"
          >
            ☰
          </button>
          <div className="app-header__brand">
            <h1>AI Secure Operations</h1>
            <span>
              Internal platform console ·{" "}
              <button
                type="button"
                className="app-header__version"
                onClick={() => setVersionOpen(true)}
                aria-label="View build information"
              >
                v{appConfig.version}
              </button>
            </span>
          </div>
        </div>
        <div className="app-header__actions">
          <span className="env-badge">{envLabel}</span>
          {userEmail ? (
            <span style={{ fontSize: "0.85rem", color: "var(--text-muted)" }}>{userEmail}</span>
          ) : null}
          <button
            type="button"
            className="btn"
            onClick={() => {
              clearToken();
              onSignOut?.();
            }}
          >
            Sign out
          </button>
        </div>
      </header>
      <VersionModal open={versionOpen} onClose={() => setVersionOpen(false)} />
    </>
  );
}
